import axios from 'axios'

const IP = process.env.REACT_APP_API_IP
const PORT = process.env.REACT_APP_API_PORT
let url = ''

if (PORT === '8081') url = `http://${IP}:${PORT}`
else url = `https://${IP}:${PORT}`

export const AxiosInstance = axios.create({
    baseURL: IP && PORT ? url : 'http://localhost:5000',
    timeout: 180000,
})

export function removeTokenFromClient() {
    delete AxiosInstance.defaults.headers.common['Authorization']
}

AxiosInstance.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        const status = error?.response?.status

        if (!error.response || status === 503) {
            window.dispatchEvent(new CustomEvent('maintenance'))
            // Return a never-settling promise so every .catch() handler in every
            // component is silently swallowed and no error alert is displayed.
            return new Promise(() => {})
        }

        const path = window.location.href
        if (status === 401 && !path.includes('/login')) {
            // Only logout for token errors (missing/invalid/expired).
            // Business-logic 401s contain a "description" or "error" field
            // with a permission message — keep the user logged in for those.
            const body = error?.response?.data
            const message: string = body?.description || body?.error || ''
            const isPermissionError =
                /forbidden|permission|permissions|insufficient/i.test(message)
            if (!isPermissionError) {
                removeTokenFromClient()
                localStorage.clear()
                window.location.href = '/login'
                return Promise.reject(error)
            }
        }
        return Promise.reject(error)
    }
)

// axios.interceptors.response.use(
//     response => {
//         console.log('EXPIRED TOKEN!')
//         return response
//     },
//     error => {
//         const dispatch = useDispatch()
//         const status = error.response?.status || 500
//         if (status === 401) {
//             console.log('EXPIRED TOKEN!')
//             removeTokenFromClient()
//             dispatch(AdminActions.methods.logoutAction())
//             navigate(RoutesEnum.LOGIN)
//             localStorage.clear()
//         } else {
//             return Promise.reject(error) // Delegate error to calling side
//         }
//     }
// )

export function setTokenInClient(token: string) {
    AxiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
